import React from 'react';
import Button from './Button';
import { updateReaction } from '../store/actions/apiActions'
import { useDispatch } from 'react-redux';

const reactions = {
    gosto: '👍',
    divertido: '😃',
    adoro: '😍',
    triste: '😢'
}

const reactionsArray = [
    ['gosto', '👍'],
    ['divertido', '😃'],
    ['adoro', '😍'],
    ['triste', '😢']
]

const Emoji = props => (
    <span
        className="emoji"
        role="img"
        aria-label={props.label ? props.label : ""}
        aria-hidden={props.label ? "false" : "true"}
    >
        {props.symbol}
    </span>
)

const EmojiButton = props => {
    const dispatch = useDispatch()
    const { symbol, number, label, index, type, item, isActive, activeItem } = props
    const classes = isActive ? `flex justify-center text-center btn-active` : `flex justify-center text-center`

    return (
        <Button
            key={index}
            onClick={() =>
                dispatch(
                    updateReaction({
                        reaction: label,
                        item: item,
                        activeItem: activeItem,
                        id: type === 'comments' ? item.date : item.id,
                        type: type,
                        action: isActive ? false : true
                    })
                )
            }
            className={classes}
        >
            <span
                className="emoji"
                role="img"
                aria-label={label ? label : ""}
                aria-hidden={label ? "false" : "true"}
            >
                {reactions[symbol]}
            </span>
            <p className='w-full'>{number}</p>
        </Button>
    )
}


export { Emoji, EmojiButton, reactionsArray }